export const enum Keys {
  TAB = 'Tab',
  ESC = 'Escape',
  SPACE = ' ',
  PAGE_UP = 'PageUp',
  PAGE_DOWN = 'PageDown',
  END = 'End',
  HOME = 'Home',
  LEFT = 'ArrowLeft',
  UP = 'ArrowUp',
  RIGHT = 'ArrowRight',
  DOWN = 'ArrowDown',
  ENTER = 'Enter',
}
